import { AxiosInstance } from "axios";
import type {
  TrelloBoard,
  TrelloLabel,
  TrelloList,
  TrelloMember,
} from "./TrelloSourceSettings.types";

export class TrelloSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getBoards(boardId: string, connectionId: string): Promise<TrelloBoard[]> {
    const response = await this.client.get<TrelloBoard[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/trello/boards`,
    );

    return response.data;
  }

  async getLists(
    boardId: string,
    connectionId: string,
    trelloBoardId: string,
  ): Promise<TrelloList[]> {
    const response = await this.client.get<TrelloList[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/trello/boards/${encodeURIComponent(trelloBoardId)}/lists`,
    );

    return response.data;
  }

  async getLabels(
    boardId: string,
    connectionId: string,
    trelloBoardId: string,
  ): Promise<TrelloLabel[]> {
    const response = await this.client.get<TrelloLabel[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/trello/boards/${encodeURIComponent(trelloBoardId)}/labels`,
    );

    return response.data;
  }

  async getMembers(
    boardId: string,
    connectionId: string,
    trelloBoardId: string,
  ): Promise<TrelloMember[]> {
    const response = await this.client.get<TrelloMember[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/trello/boards/${encodeURIComponent(trelloBoardId)}/members`,
    );

    return response.data;
  }
}
